export enum OAuthInfoEventTypes {
    Logout = 'logout',
    TokenExpire = 'token_expires'
}